export default __webpack_public_path__ + "static/media/descending_sort.5c73199e.svg";